import { render, staticRenderFns } from "./RogueClassifiedsContainer.vue?vue&type=template&id=1834704c&scoped=true&"
import script from "./RogueClassifiedsContainer.vue?vue&type=script&lang=ts&"
export * from "./RogueClassifiedsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834704c",
  null
  
)

export default component.exports